<template>
    <ul
        v-if="links.length"
        :class="'hamburger-menu__' + props.location + '-links'"
    >
        <slot name="above" />
        <li
            v-for="link in items"
            :key="link.to"
        >
            <NuxtLink
                :to="link.to"
                :external="link?.external"
            >
                {{ link.text }}
            </NuxtLink>
        </li>
        <slot name="below" />
    </ul>
</template>

<script setup>
import { useAuthStore } from '~/store/auth.js';

const props = defineProps({
    location: {
        type: String, // 'header' | 'footer' | 'main'
        default: 'main',
    },
    links: {
        type: Array,
        default: () => []
    }
});

const authStore = useAuthStore();

const items = computed(() => props.links
    // Filter out items that should not be visible for sponsors
    .filter(item => !item?.hideSponsor || !authStore?.isSponsor)
    // Filter out empty items
    .filter(item => item?.text && item?.to)
);

</script>

<style lang="less">
.hamburger-menu__main-links {
    .typography-body();
    .list-clean();
    display: grid;
    justify-content: start;
    gap: var(--spacing-sm);
    line-height: 1;
    color: var(--color-secondary);
}

.hamburger-menu__secondary-links {
    .typography-small();
    .list-clean();
    margin-top: var(--spacing-xl);
    display: grid;
    gap: var(--spacing-sm);
    line-height: 1;
    color: var(--color-darkest);
}

.hamburger-menu__footer-links {
    .list-clean();
    display: flex;
    gap: var(--spacing-md);
    line-height: 1;
    font-size: .75rem;
}
</style>
